import { Button, Col, Row } from 'reactstrap';
import ContentLoader from 'react-content-loader';
import Modal from '../../../components/modal/Modal';
import { useEffect, useState } from 'react';
import { getAnnualStatements } from '../src/statementApis';
import { useDict } from '../../../contexts/LanguageContext';

const AnnualStatementModal = (props) => {
    const dict = useDict();
    const { handleClose, isOpen } = props;

    const [annualStatementListData, setAnnualStatementListData] = useState([]);
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        setIsFetching(true);
        getAnnualStatements(handleGetAnnualStatements);
        setIsFetching(false);
    }, []);

    const handleGetAnnualStatements = (response) => {
        setAnnualStatementListData(response);
    };

    const renderContent = () => {
        if (isFetching) {
            return (
                <ContentLoader
                    className="w-100 h-100"
                    gradientDirection="top-bottom"
                >
                    <rect
                        x="0"
                        y="0"
                        rx="20"
                        ry="20"
                        width="100%"
                        height="43"
                    />
                    <rect
                        x="0"
                        y="59"
                        rx="20"
                        ry="20"
                        width="100%"
                        height="43"
                    />
                    <rect
                        x="0"
                        y="118"
                        rx="20"
                        ry="20"
                        width="100%"
                        height="43"
                    />
                </ContentLoader>
            );
        }

        if (annualStatementListData && annualStatementListData.length > 0) {
            return annualStatementListData?.map((year) => (
                <Button
                    className="btn-outline-primary rounded w-100"
                    onClick={() => { }}
                >
                    {year}
                </Button>
            ));
        }
        return (
            <p className="text-center">
                {dict.noStatementsAvailable}
            </p>
        );
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={handleClose}
            title="Annual Statements"
            headerType="review-2"
            onCancel={handleClose}
            cancelText={dict.close}
            testID="annualStatementModal"
            bodyClassName="pt-0"
        >
            <div className="modal__body" data-cy="modal__content">
                {annualStatementListData &&
                    annualStatementListData.length > 0 ? (
                    <p className="font-italic mt-2 mb-1">
                        <small>Select a year to download the statement.</small>
                    </p>
                ) : null}
                <Row className="mt-3 g-0">
                    <Col
                        className={
                            annualStatementListData &&
                                annualStatementListData.length > 0
                                ? 'statement-download-col overflowYScroll'
                                : 'statement-download-col overflowYHidden'
                        }
                    >
                        {renderContent()}
                    </Col>
                </Row>
            </div>
        </Modal>
    );
};

export default AnnualStatementModal;
